import { MixpanelEventNameType, MixpanelTrackType } from '../type';

export const trackAndHideAction = ({
  track,
  onHideDropdownContent,
}: {
  track: MixpanelTrackType<MixpanelEventNameType>;
  onHideDropdownContent: () => void;
}) => (eventName: MixpanelEventNameType) => {
  onHideDropdownContent();
  track(eventName);
};

export const openUrl = (url: string) => () => window.open(url);
